import dayjs from "dayjs"
import DatePicker from "react-datepicker"
import {
  useFormContext,
  type FieldPath,
  type FieldValues,
} from "react-hook-form"

import {
  FormField,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { cn } from "@/lib/utils"

export type FormDatePickerProps<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  label?: string
  placeholder: string
  dateFormat?: string
  className?: string
  initialValue?: string
  maxDate?: Date
}

export function FormDatePicker<T extends FieldValues = FieldValues>({
  name,
  label,
  placeholder,
  dateFormat = "yyyy-MM-dd",
  className,
  initialValue,
  maxDate,
}: FormDatePickerProps<T>) {
  const form = useFormContext<T>()
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="w-full">
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <div className="w-full">
              <DatePicker
                placeholderText={placeholder}
                selected={
                  field.value
                    ? dayjs(field.value, "YYYY-MM-DD").toDate()
                    : initialValue
                      ? dayjs(initialValue, "YYYY-MM-DD").toDate()
                      : undefined
                }
                onChange={(date) => {
                  const formattedDate = date
                    ? dayjs(date).format("YYYY-MM-DD")
                    : ""
                  field.onChange(formattedDate)
                }}
                dateFormat={dateFormat}
                wrapperClassName="w-full"
                className={cn(
                  "form-input form-input-background text-sm",
                  className,
                )}
                showYearDropdown
                dropdownMode="select"
                maxDate={maxDate}
              />
            </div>
          </FormControl>
          <FormMessage className="form-error" />
        </FormItem>
      )}
    />
  )
}
